import React from "react";
import {
    CardBottom,
    CardTop,
    IconStatWrapper,
    Line, PlayerAge, PlayerImage, PlayerNationality, PlayerPosition,
    PlayerStat,
    PlayerStatsContainer,
    PlayerTitle,
    StatBox,
    StatNumber,
    StyledCard
} from "./PlayerCard.styles";
import Logo from "../../../components/logos/Logo/Logo";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFutbol, faHandshake} from "@fortawesome/free-solid-svg-icons";

const PlayerCard = ({name, surname, position, dateOfBirth, nationality, numberOfGoals, numberOfMatches}) => {

    const calculateAge = birthDate => Math.floor((new Date() - new Date(birthDate).getTime()) / 3.15576e+10);

    return (
        <StyledCard>
            <CardTop>
                <PlayerImage src={'/player.png'}/>
                <Logo style={{
                    position: 'absolute',
                    right: -60,
                    top: -10,
                    transform: 'rotate(5deg)',
                    opacity: 0.07,
                    width: 350,
                    height: 350,
                }}/>
                <PlayerNationality
                    key={nationality}
                    alt={nationality}
                    src={'https://purecatamphetamine.github.io/country-flag-icons/3x2/' + nationality.toUpperCase() + '.svg'}
                />
                <PlayerPosition position={position}>
                    {position === 'goalkeeper' ? 'GK' :
                        position === 'defender' ? 'O' :
                            position === 'midfielder' ? 'P' : 'N'}
                </PlayerPosition>
                {dateOfBirth && <PlayerAge>{calculateAge(dateOfBirth)}</PlayerAge>}
                <Logo style={{
                    position: 'absolute',
                    left: 10,
                    top: 160,
                    width: 30,
                    height: 30,
                }}/>
            </CardTop>
            <PlayerTitle>{name + ' ' + surname}</PlayerTitle>
            <CardBottom>
                <PlayerStatsContainer>
                    <StatBox>
                        <IconStatWrapper>
                            <FontAwesomeIcon icon={faHandshake}
                                             color={'#808080'}
                                             style={{width: 50, height: 50}}

                            />
                            <StatNumber>{numberOfMatches}</StatNumber>
                        </IconStatWrapper>
                        <PlayerStat>{'Mecze'}</PlayerStat>
                    </StatBox>
                    <Line/>
                    <StatBox>
                        <IconStatWrapper>
                            <FontAwesomeIcon icon={faFutbol}
                                             color={'#808080'}
                                             style={{width: 50, height: 50}}
                            />
                            <StatNumber>{numberOfGoals}</StatNumber>
                        </IconStatWrapper>
                        <PlayerStat>{'Gole'}</PlayerStat>
                    </StatBox>
                </PlayerStatsContainer>
            </CardBottom>
        </StyledCard>
    );
};

export default PlayerCard;
